<template>
  <v-dialog
    v-model="dialog"
    max-width="600"
  >
    <v-card>
      <v-card-text>
        <v-checkbox
          v-model="noRequisites"
          label="Без реквизитов"
        ></v-checkbox>
        <template v-if="!noRequisites">
        <v-select
          :items="entities"
          v-model="entity_id"
          item-text="name"
          item-value="id"
          label="Юридическое лицо"
          :disabled="!entities.length"
          @change="onEntityChange"
        ></v-select>
        <v-select
          :items="contractsFiltered"
          v-model="contract_id"
          item-text="name"
          item-value="id"
          label="Договор"
          :disabled="!entity_id || !contractsFiltered.length"
        ></v-select>
        <v-select
          :items="accountsFiltered"
          v-model="account_id"
          item-text="name"
          item-value="id"
          label="Расчетный счет"
          :disabled="!entity_id || !accountsFiltered.length"
        ></v-select>
        </template>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="accent"
          flat="flat"
          @click="dialog = false"
        >
          Закрыть
        </v-btn>
        <v-btn
          color="accent"
          flat="flat"
          @click="excel"
          :disabled="!(noRequisites || (entity_id && account_id && contract_id))"
        >
          Excel
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import UserApi from 'app/user/api'

export default {
  name: 'SchetEntitiesModal',
  data () {
    return {
      dialog: false,
      entity_id: false,
      contract_id: false,
      account_id: false,
      noRequisites: false,
      entities: [],
      contracts: [],
      accounts: []
    }
  },
  computed: {
    contractsFiltered () {
      return this.contracts.filter(contract => contract.entity_id === this.entity_id)
    },
    accountsFiltered () {
      return this.accounts.filter(account => account.entity_id === this.entity_id)
    }
  },
  methods: {
    async open () {
      this.entity_id = false
      this.contract_id = false
      this.account_id = false
      let response = await UserApi.entities()
      this.entities = response.entities || []
      if (!this.entities.length) {
        this.noRequisites = true
      }
      this.accounts = response.accounts || []
      this.contracts = response.contracts || []

      this.entities.forEach((entity) => {
        if (entity.default_entity) {
          this.entity_id = entity.id
        }
      })

      this.setDefaultEntityInfo()
      this.dialog = true
    },
    excel () {
      this.$emit('excel', this.noRequisites ? {} : {
        entity_id: this.entity_id,
        account_id: this.account_id,
        contract_id: this.contract_id
      })
    },
    onEntityChange () {
      this.contract_id = false
      this.account_id = false
      this.setDefaultEntityInfo()
    },
    setDefaultEntityInfo () {
      if (this.entity_id) {
        this.contractsFiltered.forEach((contract) => {
          if (contract.default_contract) {
            this.contract_id = contract.id
          }
        })
        this.accountsFiltered.forEach((account) => {
          if (account.default_account) {
            this.account_id = account.id
          }
        })
      }
    }
  },
  async beforeMount () {

  }
}
</script>

<style scoped>

</style>
